import { PropsWithChildren, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { I18nProvider } from 'react-aria-components';
import { initializeMoment } from 'v5/i18n.moment';
import { useRouteMatchesPublicPaths } from 'v5/i18n.publicPaths';
import { internalInstance } from './i18n.internal';
import { publicInstance } from './i18n.public';

function ReactAriaI18nProvider({
  children,
  locale
}: PropsWithChildren<{ locale: string }>) {
  return <I18nProvider locale={locale}>{children}</I18nProvider>;
}

export function PublicLocaleProvider(props: PropsWithChildren) {
  const locale = publicInstance.language ?? 'en';
  return (
    <I18nextProvider i18n={publicInstance} {...props}>
      <ReactAriaI18nProvider locale={locale}>
        {props.children}
      </ReactAriaI18nProvider>
    </I18nextProvider>
  );
}

export function InternalLocaleProvider(props: PropsWithChildren) {
  const locale = internalInstance.language ?? 'en';
  return (
    <I18nextProvider i18n={internalInstance} {...props}>
      <ReactAriaI18nProvider locale={locale}>
        {props.children}
      </ReactAriaI18nProvider>
    </I18nextProvider>
  );
}

/**
 * moment is a global singleton, so we need to set the locale globally, just before rendering it in current language
 */
export function MomentLocaleGlobalConfigurator() {
  const matchesPublic = useRouteMatchesPublicPaths();

  useEffect(() => {
    const currentInstance = matchesPublic ? publicInstance : internalInstance;
    return initializeMoment(currentInstance, currentInstance.language);
  }, [matchesPublic]);
  return null;
}
